/**
 * Admin åpnes fra kontoen: broen (POST /api/konto/admin-bro) gir en admin-økt, og
 * så lastes /admin. Brukes av Admin-knappen i topplinja og av /admin/login.
 */
import { api, type AppUser } from './api.ts';

/** Kontoen kan åpne admin: superadmin, eller klubbadmin for minst én klubb. */
export function kanAapneAdmin(u: AppUser | null | undefined): boolean {
  return !!u && (!!u.isSuperadmin || (u.klubbadminForeninger?.length ?? 0) > 0);
}

export async function aapneAdmin(): Promise<void> {
  await api.kontoAdminBro();
  window.location.href = '/admin';
}
